export default "__VITE_ASSET__DqJsg1W1__"